export default class TricsSystemInfoViewModel {
    public version: string = ""
    public numberOfMembers: number = 0
    public numberOfSites: number = 0
    public daysofData: number = 0
}
